<script setup>
import { toRef } from "vue";
import SvgIcon from "@/shared/ui/svg-icon/SvgIcon.vue";
import { useOrganizationName } from "@/entities/organization";

const props = defineProps({
  organizationId: { type: [Number, String], default: null },
  organizationName: { type: String, default: null },
});

const { name, isLoading } = useOrganizationName(
  toRef(props, "organizationId"),
  toRef(props, "organizationName")
);
</script>

<template>
  <div
    v-if="organizationId != null || organizationName"
    class="flex items-center gap-2 text-sm text-foreground/90"
  >
    <SvgIcon
      name="huge-organization"
      class="h-4 w-4 shrink-0 text-muted-foreground"
      aria-hidden="true"
      style="fill: none"
    />
    <div
      v-if="isLoading && !name"
      class="h-3.5 w-32 rounded-[var(--radius)] bg-muted animate-pulse"
    />
    <div v-else :title="name" class="truncate line-clamp-">
      {{ name || "—" }}
    </div>
  </div>
</template>
